import type { Styles } from '@adornis/ass/style.js';
import { XLink } from '@adornis/chemistry/elements/components/x-link.js';
import { customElement, property } from 'lit/decorators.js';

/**
 * @customElement cr-link
 */
@customElement('cr-link')
export class ChromiumLink extends XLink {
  @property({ type: Boolean, reflect: true, attribute: true }) public deactivated = false;

  override styles = (): Styles[] => {
    return [
      ...super.styles(),
      {
        ':host': {
          display: 'inline-flex',
          flexDirection: 'row',
          cursor: this.deactivated ? 'not-allowed !important' : 'pointer',
          color: this.colors.secondary,
          transition: 'all .125s ease-in-out',
        },
        a: {
          cursor: this.deactivated ? 'not-allowed !important' : 'pointer',
        },
        ':host(:hover)': {
          scale: this.deactivated ? '1.0' : '1.01',
          color: this.deactivated ? this.colors.neutral : this.colors.primary.shade(500),
        },
      },
    ];
  };
}
